import {
  GameInfo as TGameInfo,
  Game as TGameType
} from './sportsbook-data-levels';

export const ETimeFilterValues = {
  QUARTER_HOUR: 15,
  HALF_HOUR: 30,
  ONE_HOUR: 60,
  THREE_HOURS: 180,
  SEVEN_HOURS: 360
};

export enum EEventsLayoutListType {
  DEFAULT = 'type1',
  EXTENDED = 'type2'
}

export enum EEventsLayoutTypes {
  CARD = 'cardView',
  LIST = 'listView'
}

export enum EEventsTabsTypes {
  LIVE = 'live',
  PREMATCH = 'prematch',
  POPULAR = 'popular',
  BOOSTED = 'boosted'
}

export enum EEventsTypes {
  ALL = 'all',
  LIVE = 'live',
  PREMATCH = 'prematch',
  POPULAR = 'popular',
  BOOSTED = 'boosted'
}

export enum EEventsOrderTypes {
  START_TIME = 'start_ts',
  FAV_ORDER = 'favorite_order'
}

export type TEventsConfigs = {
  moduleId: `${number}`;
  type: EEventsTypes;
  eventViewLayout: EEventsLayoutTypes;
  eventViewListViewType?: EEventsLayoutListType;
  showTitle: boolean;
  showEventCategoryName: boolean;
  showAllSportsWithSlid: boolean;
  defaultEventsMinutes?: `${number}`;
  limit?: number;
  eventsGamesPerView?: number;
  popularEventsOrder?: EEventsOrderTypes;
};

export type TSport = {
  alias: string;
  id: number;
  name: string;
  type: number;
};

export type TSportsResponse = {
  sport: Record<string, TSport>;
};

type TInfo = Pick<
  TGameInfo,
  'current_game_state' | 'current_game_time' | 'score1' | 'score2'
>;

export type TGame = Pick<
  TGameType,
  | 'markets_count'
  | 'region_alias'
  | 'id'
  | 'team1_id'
  | 'team2_id'
  | 'team1_name'
  | 'team2_name'
  | 'start_ts'
  | 'is_stat_available'
  | 'market'
  | 'type'
  | 'is_blocked'
  | 'competitionId'
  | 'competitionName'
> & { info: TInfo };

export type TCompetitionWithGame = {
  id: number;
  name: string;
  order: number;
  game: Record<string, TGameType>;
};

export type TRegion = {
  id: number;
  order: number;
  competition: Record<string, TCompetitionWithGame>;
};

export type TEventsGroup = TGame & {
  regionAlias?: string;
  sportName?: string;
  competitionId?: number;
  competitionName?: string;
};

export type TEventsResponse = {
  region: Record<string, TRegion>;
};
